'use client';

const DEFAULT_LANDSCAPE_BG = '/images/landscapebackground.png';
const DEFAULT_PORTRAIT_BG = '/images/portraitbackground.png';

interface PageContentContainerProps {
  children: React.ReactNode;
  className?: string;
  showBackground?: boolean;
}

export const PageContentContainer = ({ children, className = '', showBackground = true }: PageContentContainerProps) => {
  return (
    <>
      {showBackground && (
        <style jsx global>{`
          .page-background-image {
            background-color: #18385d;
            background-size: cover;
            background-position: center;
          }
          @media (min-width: 768px) {
            .page-background-image {
              background-image: url(${DEFAULT_LANDSCAPE_BG});
            }
          }
          @media (max-width: 767px) {
            .page-background-image {
              background-image: url(${DEFAULT_PORTRAIT_BG});
            }
          }
        `}</style>
      )}
      <main
        className={`page-content-container ${showBackground ? 'page-background-image' : 'site-gradient-bg'} ${className}`}
      >
        {children}
      </main>
    </>
  );
};
